import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

const Datenschutz = () => {
  const { isDark } = useTheme();
  
  return (
    <div className={`min-h-screen transition-colors duration-300 ${isDark ? 'bg-[#0a0a0a] text-white' : 'bg-white text-gray-900'}`}>
      {/* Header */}
      <div className={`border-b ${isDark ? 'bg-[#0f0f0f] border-white/5' : 'bg-gray-50 border-gray-200'}`}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <Link to="/" className={`inline-flex items-center gap-2 transition-colors mb-4 ${isDark ? 'text-[#7BA7C2] hover:text-white' : 'text-[#5A8BA6] hover:text-gray-900'}`}>
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
          <h1 className="text-3xl font-bold">Datenschutzerklärung</h1>
          <p className={`mt-2 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Informationen zum Schutz Ihrer personenbezogenen Daten</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className={`prose max-w-none space-y-10 ${isDark ? 'prose-invert' : ''}`}>
          
          <section>
            <h2 className={`text-xl font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>Verantwortliche Stelle</h2>
            <div className={`rounded-xl p-6 border ${isDark ? 'bg-white/5 border-white/10' : 'bg-gray-50 border-gray-200'}`}>
              <p className={`mb-2 ${isDark ? 'text-gray-300' : 'text-gray-700'}`}><strong>Dion Hair Clinic GmbH</strong></p>
              <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>Schürenweg 61</p>
              <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>41063 Mönchengladbach</p>
              <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>Deutschland</p>
              <p className={`mt-4 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                <strong>Telefon:</strong> +49 2161 2963017
              </p>
              <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>
                <strong>E-Mail:</strong> <a href="mailto:datenschutz@dionhairclinic.de" className={isDark ? 'text-[#7BA7C2] hover:underline' : 'text-[#5A8BA6] hover:underline'}>datenschutz@dionhairclinic.de</a>
              </p>
            </div>
          </section>

          <section>
            <h2 className={`text-xl font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>Cookies und Tracking</h2>
            
            <h3 className={`text-lg font-medium mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`}>Arten von Cookies</h3>
            <div className="space-y-4">
              <div className={`rounded-lg p-4 border ${isDark ? 'bg-white/5 border-white/10' : 'bg-gray-50 border-gray-200'}`}>
                <h4 className={`font-medium mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>Notwendige Cookies</h4>
                <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Diese Cookies sind für den Betrieb der Website erforderlich und können in unseren Systemen nicht abgeschaltet werden.</p>
              </div>
              <div className={`rounded-lg p-4 border ${isDark ? 'bg-white/5 border-white/10' : 'bg-gray-50 border-gray-200'}`}>
                <h4 className={`font-medium mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>Analyse-Cookies</h4>
                <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Diese Cookies ermöglichen es uns, Besuche und Verkehrsquellen zu zählen, damit wir die Leistung unserer Website messen und verbessern können.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className={`text-xl font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>Rechte der betroffenen Personen</h2>
            <p className={`mb-4 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Sie haben jederzeit folgende Rechte:</p>
            <ul className={`list-disc list-inside space-y-2 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
              <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
              <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
              <li>Recht auf Löschung (Art. 17 DSGVO)</li>
              <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
              <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
            </ul>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
